<template>
  <div class="panel panel-default" style="border: 1px solid #ccc; background-color: white">
    <div class="panel-heading">
      <h4 class="panel-title">
        <a href="javascript://void(0)" @click="toggleShowAll">
          <i v-if="collapseSection" class="fa fa-angle-right" aria-hidden="true"></i>
          <i v-else class="fa fa-angle-down" aria-hidden="true"></i>
          {{ unit.Id }}
        </a>
      </h4>
    </div>
    <div class="panel-collapse" :class="{ collapse: this.collapseSection }" style="background-color: white">
      <div class="panel-body" style="background-color: white">
        <div v-for="address in unit.addresses" :key="address.Id">

          <ul class="list-group">
            <li class="list-group-item">
              <div class="form-group">
                <div class="row form-group">
                  <div class="col-xs-6">
                    <dl class="no-margin">
                      <dt>Id</dt>
                      <dd>
                        {{ address.address.Id }}
                      </dd>
                    </dl>
                  </div>
                  <div class="col-xs-6">
                    <dl class="no-margin">
                      <dt>Type</dt>
                      <dd> {{ address.address.Type }}</dd>
                    </dl>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-xs-6">
                    <dl class="no-margin">
                      <dt>Address</dt>
                      <dd>
                        {{ address.address.Address }} {{ address.address.Address2 }}
                      </dd>
                    </dl>
                  </div>
                  <div class="col-xs-6">
                    <dl class="no-margin">
                      <dt>City</dt>
                      <dd> {{ address.address.City }}</dd>
                    </dl>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-xs-6">
                    <dl class="no-margin">
                      <dt>State</dt>
                      <dd>
                        {{ address.address.State }}
                      </dd>
                    </dl>
                  </div>
                  <div class="col-xs-6">
                    <dl class="no-margin">
                      <dt>Zip</dt>
                      <dd> {{ address.address.PostalCode }}</dd>
                    </dl>
                  </div>
                </div>

              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="loading">
        <amenity-manatee-loading></amenity-manatee-loading>
      </div>
      <div v-else>
        <div v-if="loadedResident">
          <div v-for="occupancyTerm in occupancyTerms" :key="occupancyTerm.Id">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="form-group">
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Id</dt>
                        <dd>
                          {{ occupancyTerm.Id }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Type</dt>
                        <dd> {{ occupancyTerm.Type }}</dd>
                      </dl>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Term Start</dt>
                        <dd>
                          {{ occupancyTerm.TermStartDate }}
                        </dd>
                      </dl>
                    </div>
                    <div class="col-xs-6">
                      <dl class="no-margin">
                        <dt>Term End</dt>
                        <dd> {{ occupancyTerm.TermEndDate }}</dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </li>
            </ul>


            <div v-for="occupancyTermResident in occupancyTerm.occupancyTermResidents" :key="occupancyTermResident.Id">

              <ul class="list-group">
                <li class="list-group-item">
                  <div class="form-group">
                    <div class="row form-group">
                      <div class="col-xs-6">
                        <dl class="no-margin">
                          <dt>Resident Id</dt>
                          <dd>
                            {{ occupancyTermResident.Id }}
                          </dd>
                        </dl>
                      </div>
                      <div class="col-xs-6">
                        <dl class="no-margin">
                          <dt>Type</dt>
                          <dd> {{ occupancyTermResident.OccupancyTermResidentTypeId }}</dd>
                        </dl>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-xs-6">
                        <dl class="no-margin">
                          <dt>Term Start</dt>
                          <dd>
                            {{ occupancyTermResident.resident.FirstName }}
                          </dd>
                        </dl>
                      </div>
                      <div class="col-xs-6">
                        <dl class="no-margin">
                          <dt>Term End</dt>
                          <dd> {{ occupancyTermResident.resident.LastName}}</dd>
                        </dl>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-xs-12">
                        <dl class="no-margin">
                          <dt>Emails</dt>
                          <dd>
                            <div v-for="email in occupancyTermResident.resident.emails" :key="email.Id">
                              {{ email.Email }}
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-xs-12">
                        <dl class="no-margin">
                          <dt>Phone Numbers</dt>
                          <dd>
                            <div v-for="phoneNumber in occupancyTermResident.resident.phoneNumbers" :key="phoneNumber.Id">
                              {{ phoneNumber.Phone }}
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    unit: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      occupancyTerms: [],
      page: 1,
      pageCount: 0,
      loading: false,
      loadedResident: false,
      collapseSection: true,
    };
  },
  computed: {

  },
  methods: {
    fetchData() {
      if (this.loading) return;
      this.loading = true;
      var url = "/core/unit2/" + this.unit.Id + "/residents";
      console.log(this.page);
      axios.get(url)
        .then((response) => {
          console.log(response.data.data);
          this.occupancyTerms = response.data.data;
          this.loading = false;
          this.loadedResident = true;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    toggleShowAll() {
      this.collapseSection = !this.collapseSection;
      if (this.loadedResident === false) {
        this.fetchData();

      }
    },
  },
  mounted() {
  }
};
</script>